import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ContactInfo } from '../../Utils/Data';
import { useLocalizedStatic } from '../../i18n/useLocalizedStatic';
import { SITE_LOGO } from '../../Utils/siteConfig';
import LanguageSwitcher from './LanguageSwitcher';

const NAV_ITEMS = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Services', to: '/services' },
  { label: 'Projects', to: '/projects' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contact', to: '/contact' },
];


const isNavActive = (pathname, to) => {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
};

const HEADER_COPY = {
  downloadBrochure: 'Download Browcher',
  contact: 'Contact',
  email: 'Email',
  freeCall: 'Free Call',
};

function Header() {
  const menuRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navItems = useLocalizedStatic(NAV_ITEMS);
  const copy = useLocalizedStatic(HEADER_COPY);

  const closeMobileMenu = useCallback(() => {
    setMobileMenuOpen(false);
  }, []);

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen((open) => !open);
  }, []);

  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname, closeMobileMenu]);

  useEffect(() => {
    document.body.classList.toggle('nav-expanded', mobileMenuOpen);
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.classList.remove('nav-expanded');
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    const $ = window.jQuery;
    const $menu = $(menuRef.current);
    if (!$ || !$menu.length) return undefined;

    const onScroll = () => {
      const scroll = $(window).scrollTop();
      if (scroll < 1) {
        $menu.removeClass('sticky');
      } else {
        $menu.addClass('sticky');
      }
    };

    $(window).on('scroll.stickyHeader', onScroll);
    onScroll();

    return () => {
      $(window).off('scroll.stickyHeader');
      $menu.removeClass('sticky');
    };
  }, []);

  return (
    <>
         <div className="full-width-header">
  <header id="rs-header" className="rs-header" data-react-mobile-menu>
    <div className="toolbar-area topbar-style1 hidden-md">
      <div className="container">
        <div className="row rs-vertical-middle">
          <div className="col-lg-7">
            <div className="toolbar-contact">
              <ul className="rs-contact-info">
                <li>
                  <i className="fi fi-rr-envelope-plus" />
                  <a href={`mailto:${ContactInfo.contact_email}`}>{ContactInfo.contact_email}</a>
                </li>
                <li>
                  <i className="fi fi-rr-phone-call" />
                        <a href={`tel:${ContactInfo.contact_phone}`}>{ContactInfo.contact_phone}</a>
                </li>
                <li>
                  <i className="fi fi-rr-map-marker-home" />
                        {ContactInfo.top_header_address}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="toolbar-sl-share">
              <ul className="clearfix">
                <li className="opening">
                  <em>
                          <i className="fi fi-rr-time-add" /> {ContactInfo.office_hours}
                        </em>
                </li>
                <li>
                        <a href={ContactInfo.facebook} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                        <a href={ContactInfo.X} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li>
                        <a href={ContactInfo.instagram} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-pinterest-p" />
                  </a>
                </li>
                <li>
                        <a href={ContactInfo.instagram} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

          <div className="menu-area menu-sticky" ref={menuRef}>
      <div className="container">
        <div className="row-table">
          <div className="col-cell header-logo">
            <div className="logo-area">
                    <Link to="/">
                      <img className="site-logo" src={SITE_LOGO} alt="Q-Tech Contracting" />
                    </Link>
            </div>
          </div>
                <div className="col-cell header-nav">
            <div className="rs-menu-area">
              <div className="main-menu">
                <nav className="rs-menu hidden-md">
                  <ul className="nav-menu">
                          {navItems.map((item) => (
                            <li key={item.to} className={isNavActive(location.pathname, item.to) ? ' current-menu-item' : undefined}>
                              <Link to={item.to}>{item.label}</Link>
                            </li>
                          ))}
                      </ul>
                </nav>
                    </div>
            </div>
          </div>
                <div className="col-cell header-actions">
            <div className="expand-btn-inner">
              <ul>
                      <LanguageSwitcher />
                <li className="btn-quote">
                        <Link className="quote-button" to="/contact">
                          {copy.downloadBrochure}
                        </Link>
                </li>
                <li className="humburger">
                        <button
                          type="button"
                          className="nav-expander bar mobile-menu-toggle"
                          aria-label="Open menu"
                          aria-expanded={mobileMenuOpen}
                          onClick={toggleMobileMenu}
                        >
                    <div className="bar">
                      <span className="dot1" />
                      <span className="dot2" />
                      <span className="dot3" />
                      <span className="dot4" />
                      <span className="dot5" />
                      <span className="dot6" />
                      <span className="dot7" />
                      <span className="dot8" />
                      <span className="dot9" />
                    </div>
                        </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

          <nav
            className={`right_menu_togle mobile-navbar-menu${mobileMenuOpen ? ' is-open' : ''}`}
            id="mobile-navbar-menu"
            aria-hidden={!mobileMenuOpen}
          >
            <div className="mobile-menu-top">
              <Link to="/" className="canvas-logo" onClick={closeMobileMenu}>
                <img src={SITE_LOGO} alt="Q-Tech Contracting" />
              </Link>
              <div className="close-btn hash-has-sub">
                <button
                  type="button"
                  className="nav-close hash mobile-menu-close"
                  aria-label="Close menu"
                  onClick={closeMobileMenu}
                >
                  <div className="line">
                    <span className="line1" />
                    <span className="line2" />
                  </div>
                </button>
              </div>
            </div>
      <ul className="nav-menu">
              {navItems.map((item) => (
                <li key={`mobile-${item.to}`} className={`hash-has-sub${isNavActive(location.pathname, item.to) ? ' active-menu' : ''}`}>
                  <Link to={item.to} className="hash" onClick={closeMobileMenu}>
                    {item.label}
                  </Link>
                </li>
              ))}
          </ul>
      <div className="canvas-contact">
        <div className="address-area">
          <div className="address-list">
            <div className="info-icon">
              <i className="fi fi-rr-map-marker-home" />
            </div>
            <div className="info-content">
                    <h4 className="title">{copy.contact}</h4>
                    <em>
                      {ContactInfo.office_address_line1}, {ContactInfo.office_address_line2}
                    </em>
            </div>
          </div>
          <div className="address-list">
            <div className="info-icon">
              <i className="fi fi-rr-envelope-plus" />
            </div>
            <div className="info-content">
                    <h4 className="title">{copy.email}</h4>
              <em className="hash-has-sub">
                      <a href={`mailto:${ContactInfo.contact_email}`} className="hash">
                        {ContactInfo.contact_email}
                </a>
              </em>
            </div>
          </div>
          <div className="address-list">
            <div className="info-icon">
              <i className="fi fi-rr-phone-call" />
            </div>
            <div className="info-content">
                    <h4 className="title">{copy.freeCall}</h4>
                    <em>{ContactInfo.contact_phone}</em>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</div>
      <div
        className={`mobile-menu-backdrop${mobileMenuOpen ? ' is-visible' : ''}`}
        role="presentation"
        aria-hidden={!mobileMenuOpen}
        onClick={closeMobileMenu}
      />
    </>
  );
}

export default Header;
